if (!customElements.get('product-popup')) {
  customElements.define('product-popup', class ProductPopup extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.overlay = this.querySelector('[data-popup-overlay]');
      this.dialog = this.querySelector('[data-popup-dialog]');
      this.closeButton = this.querySelector('[data-popup-close]');

      if (!this.overlay || !this.dialog || !this.closeButton) return;

      this.dataset.initialized = 'true';
      this.onDocumentClickHandler = this.onDocumentClick.bind(this);
      this.onKeydownHandler = this.onKeydown.bind(this);
      this.onCloseClickHandler = this.close.bind(this);

      document.addEventListener('click', this.onDocumentClickHandler);
      document.addEventListener('keydown', this.onKeydownHandler);
      this.overlay.addEventListener('click', this.onCloseClickHandler);
      this.closeButton.addEventListener('click', this.onCloseClickHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClickHandler);
      document.removeEventListener('keydown', this.onKeydownHandler);
      this.overlay?.removeEventListener('click', this.onCloseClickHandler);
      this.closeButton?.removeEventListener('click', this.onCloseClickHandler);
    }

    onDocumentClick(event) {
      const trigger = event.target.closest('.image-popup-enabled img');
      if (!trigger) return;

      this.open(trigger);
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.dialog.getAttribute('aria-hidden') === 'false') {
        this.close();
      }
    }

    open(trigger) {
      this.activeTrigger = trigger;
      this.overlay.style.display = 'block';
      this.dialog.style.display = 'flex';
      this.dialog.setAttribute('aria-hidden', 'false');
      this.closeButton.focus({ preventScroll: true });
    }

    close() {
      this.overlay.style.display = 'none';
      this.dialog.style.display = 'none';
      this.dialog.setAttribute('aria-hidden', 'true');
      this.activeTrigger?.focus?.({ preventScroll: true });
      this.activeTrigger = null;
    }
  });
}
